import { Operation, op } from "libs/transaction";
import { JoinTable, RecordPointer, RecordTable } from "libs/schema";

export function undeleteOperation(pointer: RecordPointer<RecordTable | JoinTable>): Operation {
  return op.update(pointer, {
    deleted_at: null,
    deleted_by_user_id: null,
  });
}
